import { createContext, useContext } from "react";
import { SheetMeta } from "./SheetContainerContext";

interface SheetContext extends SheetMeta {
  /**
   * Toggles whether the sheet is currently open
   */
  toggleCollapse: () => void;
}

export interface ActiveSheet extends SheetContext {
  /**
   * Getter for the previous sheet's context.
   * Returns undefined if there is no previous sheet.
   */
  getPreviousSheet: () => SheetContext | undefined;
}

export const ActiveSheetContext = createContext<{
  sheet?: ActiveSheet;
}>({
  sheet: undefined
});

/**
 * Provides the currently active sheet's metadata including a getter for the previous sheet.
 */
export function useActiveSheet() {
  return useContext(ActiveSheetContext);
}
